import { useEffect, useState, type ReactNode } from "react";
import { timer } from "rxjs";
import { ClipLoading } from ".";

export interface DelayedClipLoadingProps {
  loading: boolean;
  /** loading 持续超过该毫秒数才展示 spinner，默认 200 */
  delay?: number;
  /** 透传给 ClipLoading 容器 */
  className?: string;
  LoadingElement?: () => JSX.Element;
  /** delay 窗口内（loading=true 但还没到 delay）的占位内容，默认 null */
  placeholder?: ReactNode;
  children?: ReactNode;
}

export const DelayedClipLoading = ({
  loading,
  delay = 100,
  className,
  placeholder = null,
  children,
  LoadingElement,
}: DelayedClipLoadingProps) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowLoading(false);
      return;
    }
    const sub = timer(delay).subscribe(() => setShowLoading(true));
    return () => sub.unsubscribe();
  }, [loading, delay]);

  if (loading) {
    return showLoading ? (
      LoadingElement ? (
        <LoadingElement />
      ) : (
        <ClipLoading className={className} />
      )
    ) : (
      <>{placeholder}</>
    );
  }
  return children;
};
